namespace RioERP.Orders {
    export interface RazorPaySettingsForm {
        KeyId: Serenity.StringEditor;
        KeySecret: Serenity.StringEditor;
        WebhookSecret: Serenity.StringEditor;
        WebhookUrl: Serenity.StringEditor;
        RedirectUrl: Serenity.StringEditor;
    }

    export class RazorPaySettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.RazorPaySettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RazorPaySettingsForm.init)  {
                RazorPaySettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(RazorPaySettingsForm, [
                    'KeyId', w0,
                    'KeySecret', w0,
                    'WebhookSecret', w0,
                    'WebhookUrl', w0,
                    'RedirectUrl', w0
                ]);
            }
        }
    }
}
